import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["inert"]

import { inject } from "vue";
import { studioSidebarKey } from "./studioSidebar";
import { studioEditorActiveKey } from "./studioSessionHistory";

export default /*@__PURE__*/_defineComponent({
  __name: 'StudioSidebarContent',
  setup(__props) {

const target = inject(studioSidebarKey, undefined);
const active = inject(studioEditorActiveKey, () => true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, {
    to: _unref(target) || 'body',
    disabled: !_unref(target)
  }, [
    _withDirectives(_createElementVNode("div", {
      inert: !_unref(active)(),
      class: "studio-sidebar-session"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_1), [
      [_vShow, _unref(active)()]
    ])
  ], 8, ["to", "disabled"]))
}
}

})